import { Helmet } from "react-helmet-async";
import { WaveBackground } from "@/components/main-page/WaveBackground";

export function OgImagePage() {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div
        style={{
          width: 1200,
          height: 630,
          position: "relative",
          overflow: "hidden",
          background: "#0a0a0a",
        }}
      >
        <div style={{ position: "absolute", inset: 0 }}>
          <WaveBackground scrollProgress={0} />
        </div>

        <div
          style={{
            position: "relative",
            zIndex: 1,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 36,
            paddingTop: 20,
          }}
        >
          <img
            src="/logo-og.svg"
            alt="COSX"
            style={{ height: 52 }}
          />
          <p
            style={{
              fontFamily: "var(--font-display)",
              fontSize: 36,
              fontWeight: 300,
              letterSpacing: "-0.01em",
              color: "rgba(255,255,255,0.7)",
              textAlign: "center",
              maxWidth: 640,
              lineHeight: 1.4,
              margin: 0,
            }}
          >
            AI agents for regulated industries
          </p>
        </div>
      </div>
    </>
  );
}
